import { useCallback, useState } from "react";
import { useLazyQuery } from "@apollo/client";
import { GET_REFERRAL } from "../queries/referral";
import { getSentReferral } from "../state/ducks/referralsSent";
import { getReceivedReferral } from "../state/ducks/referralsReceived";
import { useDispatch, useSelector } from "react-redux";

export const useFetchReferral = () => {
  const clientId = useSelector((state) => state.auth.clientId);
  const [fetchReferral] = useLazyQuery(GET_REFERRAL);
  const [trackedRequestCount, setTrackedRequestCount] = useState(0);
  const dispatch = useDispatch();

  const handleFetchReferral = useCallback(
    async (referralId, options = { inspectReferral: true }) => {
      const {
        syncStore = true,
        fetchPolicy,
        trackLoading = false,
        inspectReferral = true,
        ...dispatchOptions
      } = options;

      if (trackLoading) {
        setTrackedRequestCount((currentCount) => currentCount + 1);
      }

      try {
        const { data: referralData } = await fetchReferral({
          variables: {
            clientId,
            processInstanceId: referralId,
          },
          skip: !referralId,
          ...(fetchPolicy && { fetchPolicy }),
        });

        if (referralData?.referral?.id) {
          if (syncStore) {
            const syncOptions = {
              inspectReferral,
              ...dispatchOptions,
            };

            if (referralData?.referral?.type === "SENT") {
              dispatch(getSentReferral(referralData?.referral, syncOptions));
            } else {
              dispatch(
                getReceivedReferral(referralData?.referral, syncOptions)
              );
            }
          }

          return referralData.referral;
        }

        return null;
      } finally {
        // We can refactor this later by splitting the hook's responsibilities
        if (trackLoading) {
          setTrackedRequestCount((currentCount) =>
            Math.max(0, currentCount - 1)
          );
        }
      }
    },
    [clientId, dispatch, fetchReferral]
  );

  const loadingReferral = trackedRequestCount > 0;

  return { handleFetchReferral, loadingReferral };
};

export default useFetchReferral;
